import { RootState } from '../../rootReducer';

export const usersSelectors = {
  getUserApiResult: (state: RootState) => state.UserState.apiRequestResult,
  getUserInstitutions: (state: RootState) => state.UserState.institutions,
  getUserSearchAdvancedResult: (state: RootState) =>
    state.UserState.searchUserAdvancedResult,
  getUserSearchResult: (state: RootState) => state.UserState.searchUserResult,
  getUserViewingInstitution: (state: RootState) =>
    state.UserState.viewingInstitution,
  getUsers: (state: RootState) => state.UserState.users,

  getKnownUsers: (state: RootState) => {
    const userIds = [];
    Object.values(state.CloudsState.clouds)
      ?.filter(
        (cloud) =>
          cloud.books.indexOf(state?.ReaderState?.readerData?.bookId) !== -1
      )
      .forEach((cloud) => {
        userIds.push(...cloud.members);
      });
    return (
      state.UserState.users?.filter((user) => userIds.includes(user.id)) || []
    );
  },
  getUserSearchAdvancedResultWithIds: (state: RootState) => {
    const current = {
      result: {
        ...state.UserState.searchUserAdvancedResult.result,
        items: state.UserState.searchUserAdvancedResult.result.items.map(
          (item) => {
            const newItem = {
              ...item,
              id1: 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                function (c) {
                  var r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                  return v.toString(16);
                }
              ),
            };

            return newItem;
          }
        ),
      },
    };

    return current;
  },
  getEnrolments: (state: RootState) =>
    state.UserState.searchEnrolmentAdvancedResult,
};
